var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Footer from '@marketing/components/funnel/Footer';
import Header from '@marketing/components/funnel/Header';
import WaypointScallop from '@marketing/components/funnel/WaypointScallop';
import { clsx } from 'clsx';
import { useProfileContext } from '../ProfileContext';
var ProfilePageMain = function (_a) {
    var children = _a.children, heading = _a.heading, imageData = _a.imageData;
    return (_jsx("main", __assign({ id: "main-content", className: "flex-grow w-full md:max-w-sm mx-auto" }, { children: _jsxs("div", __assign({ className: "px-6 md:px-0 py-12 md:py-15 grid grid-cols-1 gap-12 md:gap-15 text-center" }, { children: [_jsx("div", __assign({ className: "flex justify-center" }, { children: _jsx(WaypointScallop, { imageData: imageData }) })), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-8" }, { children: [_jsx("h1", __assign({ className: "text-xl-head-m md:text-xl-head-d font-display" }, { children: heading })), _jsx("p", __assign({ className: "text-sm-reg-m md:text-sm-reg-d" }, { children: children }))] }))] })) })));
};
var ProfilePageLayout = function (_a) {
    var children = _a.children, handleClickNext = _a.handleClickNext, handleClickPrevious = _a.handleClickPrevious, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var currentStep = useProfileContext().currentStep;
    return (_jsxs("div", __assign({ className: clsx('flex flex-col min-h-screen', currentStep.theme === 'dark' ? 'bg-squash' : 'bg-beige-100') }, { children: [_jsx(Header, {}), children, _jsx(Footer, { currentSection: currentStep.section, formIdOrOnNext: handleClickNext, disableNext: isLoading, onPrevious: handleClickPrevious, theme: currentStep.theme })] })));
};
export { ProfilePageLayout, ProfilePageMain };
